import { render } from "./FilterSmallAngleRange.vue?vue&type=template&id=5ba742a3&ts=true"
import script from "./FilterSmallAngleRange.vue?vue&type=script&lang=ts"
export * from "./FilterSmallAngleRange.vue?vue&type=script&lang=ts"

import "./FilterSmallAngleRange.vue?vue&type=style&index=0&id=5ba742a3&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__